import { z } from "zod";
import { ASSIGNABLE_CLINIC_ROLES } from "@fysaro/domain";

export const createUserSchema = z.object({
  role: z.enum(ASSIGNABLE_CLINIC_ROLES),
  name: z.string().min(1),
  email: z.string().email(),
  phone: z.string().optional(),
  isClient: z.boolean().default(true),
  imageUrl: z.string().url().optional(),
});

export const updateUserSchema = z.object({
  name: z.string().optional(),
  phone: z.string().optional(),
  role: z.enum(ASSIGNABLE_CLINIC_ROLES).optional(),
  isClient: z.boolean().optional(),
  status: z.enum(["active", "inactive"]).optional(),
});

export const updateAvatarSchema = z.object({
  imageUrl: z.string().url(),
});
